import React from 'react';

/**
 * ModalFooter Component
 * 
 * Footer with Cancel and Submit buttons (submit button varies by mode)
 */
const ModalFooter = ({
  mode,
  isUpdate,
  isUploading,
  linkUrl,
  selectedAttachmentId,
  onClose,
  onSubmitLink,
  onSelectAttachment,
}) => {
  return (
    <div className="deliverable-submit-modal__footer">
      <button 
        className="deliverable-submit-modal__btn deliverable-submit-modal__btn--cancel"
        onClick={onClose}
        disabled={isUploading}
      >
        Cancel
      </button>
      
      {mode === 'link' && (
        <button 
          className="deliverable-submit-modal__btn deliverable-submit-modal__btn--submit"
          onClick={onSubmitLink}
          disabled={!linkUrl.trim()}
        >
          {isUpdate ? 'Save New Link' : 'Submit Link'}
        </button>
      )}
      
      {mode === 'select' && (
        <button 
          className="deliverable-submit-modal__btn deliverable-submit-modal__btn--submit"
          onClick={onSelectAttachment}
          disabled={!selectedAttachmentId}
        >
          {isUpdate ? 'Use This Instead' : 'Use This File'}
        </button>
      )}
    </div>
  );
};

export default ModalFooter;
